import * as getTerritories from "@/api/territories/get";

export default {
	namespaced: true,
	state: {
		id: null,
		territories: [],
		error: null,
	},
	getters: {
		readId: (state) => state.id,
		readTerritories: (state) => state.territories,
		readError: (state) => {
			return state.error == "Token expired"
				? "La sesión caducó"
				: state.error;
		},
	},
	mutations: {
		SET_ID(state, payload) {
			state.id = payload;
		},
		SET_TERRITORIES(state, payload) {
			state.territories = payload;
		},
		SET_ERROR(state, payload) {
			state.error = payload;
		},
	},
	actions: {
		async getTerritories({ commit, rootGetters }) {
			let token = rootGetters["loginStore/readToken"];
			let getTerritoriesRes = await getTerritories
				.getTerritories(token)
				.then((data) => {
					if (data) {
						Array.isArray(data)
							? commit("SET_TERRITORIES", data)
							: commit("SET_TERRITORIES", [data]);
					} else {
						commit("SET_TERRITORIES", []);
					}
					return true
				})
				.catch((error) => {
					if (error.response) {
						let message =
							error.response.data.message ||
							error.response.data.detail[0].msg;
						message == "Token expired"
							? commit("loginStore/SET_ACCESS_TOKEN", null, {
									root: true,
							  })
							: message
							? commit("SET_ERROR", message)
							: commit("SET_ERROR", "Algo salió mal");
					} else {
						console.log(error);
						commit("SET_ERROR", error);
					}
				});
			return getTerritoriesRes;
		},
	},
};
